import home from '../assets/img/home_bg.webp';
import quotes from '../assets/img/quotes_bg.webp';
import contact from '../assets/img/contact_bg.webp';

export const homeImage = {
    backgroundImage: `url(${home})`,
};

export const quotesImage = {
    backgroundImage: `url(${quotes})`,
};

export const contactImage = {
    backgroundImage: `url(${contact})`,
};
